import React from "react";

import { Typography } from "@mui/material";
import { useTheme } from "@mui/material";
import { brandingSettings } from "../../branding";
interface I_ConversationTitle {
  title: string;
  active: boolean;
}

const ConversationTitle: React.FC<I_ConversationTitle> = ({
  title,
  active,
}) => {
  const theme = useTheme();
  return (
    <Typography
      sx={{
        flex: 1,
        fontSize: "14px",
        color: active ? theme.palette.primary.main : 
        theme.palette.mode === "dark" ? brandingSettings.textcolorPrimaryDark :brandingSettings.textcolorPrimary,
        fontWeight: active ? "bold" : "500" 
      }}
      className="firstlettercapital"
    >
      {title}
    </Typography>
  );
};

export default ConversationTitle;
